<template>
    <div>
        <div class="filter">
            <el-select v-model="yearFilter" placeholder="Lọc năm" size="small" @change="reloadBothTables"
                class="year-filter-select" popper-class="progress-level-year-dropdown">
                <el-option v-for="y in years" :key="y" :label="'Năm ' + y" :value="y" />
            </el-select>
        </div>
        <div class="progress-level-page">
            <!-- Top Section: Level Progress Overview & Ranking -->
            <div class="section-header">
                    <h3>Tổng quan tiến trình Level & xếp hạng của bạn</h3>
                </div>
            <div class="section-card">
                <EmployeePrivateTable :items="domainReviewItems" :loading="domainReviewLoading"
                    />
            </div>

            <!-- Bottom Section: Detailed Level Assessment & Approval -->
            <div class="section-header">
                    <h3>Chi tiết đánh giá & xét duyệt Level của bạn</h3>
                </div>
            <div class="section-card">
                <DomainProgressReviewTable :items="domainReviewItems" :loading="domainReviewLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import EmployeePrivateTable from './components/EmployeePrivateTable.vue'
import DomainProgressReviewTable from './components/DomainProgressReviewTable.vue'
import {
    GET_DOMAIN_REVIEW_LIST,
} from "@/core/services/store/progress-level/progressLevel.module";

export default {
    name: 'ProgressLevel',
    components: { EmployeePrivateTable, DomainProgressReviewTable },
    data() {
        const now = new Date().getFullYear();
        return {
            employeeProgressItems: [],
            yearFilter: now,
            years: [],
            domainReviewItems: [],
            domainReviewLoading: false,
        };
    },
    mounted() {
        this.reloadBothTables();
        this.getCurrentQuarterAndYear();
    },
    methods: {
        getCurrentQuarterAndYear() {
            const now = new Date();
            const currentYear = now.getFullYear();
            const startYear = 2025;
            this.years = Array.from({ length: Math.max(1, currentYear - startYear + 1) }, (_, i) => startYear + i);
        },

        reloadBothTables() {
            this.reloadDomainReview();
        },

        reloadDomainReview() {
            this.domainReviewLoading = true;
            const payload = {
                year: this.yearFilter
            };
            this.$store.dispatch(GET_DOMAIN_REVIEW_LIST, payload).then((res) => {
                this.domainReviewItems = res.data || [];
            }).finally(() => {
                this.domainReviewLoading = false;
            });
        },
    }
};
</script>

<style lang="scss" scoped>

.filter {
    margin-bottom: 24px;
    
}

.progress-level-page {
    background: #f8fafc;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.section-card {
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
    border-radius: 0 0 12px 12px;
    // border: 1px solid #4d1eab;
    // border-top: none;
}

.section-header {
    width: fit-content;
    background: white;
    color: #4d1eab;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #4d1eab;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    margin-bottom: 0;

    h3 {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        color: #4d1eab;
    }
}

</style>
